import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let letter = useDataValue({
    context: 'letter',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'modal',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.letters.splice(next.letters.indexOf(letter), 1)
    })
  }
}
